import React, { useState } from 'react';
import styled from 'styled-components';

const InputContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 24px;
`;

const InputField = styled.input`
  width: 100%;
  padding: 16px;
  border: 1px solid ${props => props.isFocused ? '#6c5ce7' : '#e1e1e1'};
  border-radius: 12px;
  background-color: ${props => props.isFocused ? 'rgba(108, 92, 231, 0.05)' : '#fff'};
  font-size: 16px;
  transition: all 0.3s ease;
  outline: none;
  box-shadow: ${props => props.isFocused ? '0 0 0 3px rgba(108, 92, 231, 0.15)' : 'none'};

  &::placeholder {
    color: transparent;
  }

  &:focus + label,
  &:not(:placeholder-shown) + label {
    top: -12px;
    left: 12px;
    font-size: 12px;
    padding: 0 6px;
    background-color: ${props => props.isFocused ? '#f5f5f7' : '#fff'};
  }
`;

const Label = styled.label`
  position: absolute;
  top: 16px;
  left: 16px;
  color: #666;
  font-size: 16px;
  transition: all 0.3s ease;
  pointer-events: none;
`;

const IconButton = styled.button`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
`;

const Input = ({
    label,
    name,
    type = 'text',
    placeholder = ' ',
    icon: Icon,
    iconAction,
    ...rest
}) => {
    const [isFocused, setIsFocused] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const getInputType = () => {
        if (type !== 'password') return type;
        return showPassword ? 'text' : 'password';
    };

    return (
        <InputContainer>
            <InputField
                name={name}
                id={name}
                type={getInputType()}
                placeholder={placeholder}
                onFocus={handleFocus}
                onBlur={handleBlur}
                isFocused={isFocused}
                {...rest}
            />
            <Label htmlFor={name}>{label}</Label>

            {type === 'password' && (
                <IconButton
                    type="button"
                    onClick={togglePasswordVisibility}
                >
                    {showPassword ? '👁️' : '👁️‍🗨️'}
                </IconButton>
            )}

            {Icon && iconAction && (
                <IconButton type="button" onClick={iconAction}>
                    <Icon />
                </IconButton>
            )}
        </InputContainer>
    );
};

export default Input;